import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { colors, Tag, Typography } from '@sweep-io/sweep-design';
import { Virtuoso } from 'react-virtuoso';
import pluralize from 'pluralize';

interface SearchResultsListProps<T> {
  items: T[];
  renderItem: (idx: number, item: T) => ReactNode;
  activeFilterLabel?: string;
  onClearFilter?: () => void;
}

export const SearchResultsList = <T,>({
  items,
  renderItem,
  activeFilterLabel,
  onClearFilter,
}: SearchResultsListProps<T>) => {
  if (items.length === 0) return null;

  return (
    <Stack height="100%">
      <Stack p={2} gap={1}>
        <Box>
          {activeFilterLabel && (
            <Tag
              size="tiny"
              color={colors.grey[120]}
              label={activeFilterLabel}
              onDelete={onClearFilter}
            />
          )}
        </Box>
        <Typography color={colors.grey[700]} variant="body">
          Showing {pluralize('result', items.length, true)}
        </Typography>
      </Stack>

      <Virtuoso
        style={{ height: '100%', width: '100%' }}
        data={items}
        itemContent={renderItem}
      />
    </Stack>
  );
};
